import {createContext} from "react";
export interface DrawerType {
    isOpen:boolean;
    handlerClose: ()=>any;
    handlerOpen: ()=>any;
}
export const DrawerContext = createContext<DrawerType>({isOpen:false, handlerClose:()=>{},handlerOpen:()=>{}});